import { PayloadAction } from '@reduxjs/toolkit';
import { call, put } from 'redux-saga/effects';

import { httpClient } from 'services/httpClient';
import ICompanyEditRequestBody from 'services/httpClient/requests/company/ICompanyEditRequestBody';

import { authActions } from '..';

import { ICompanyEditRequestAction } from '../reducers/editCompany/request';

function* editCompany(action: PayloadAction<ICompanyEditRequestAction>) {
  try {
    const body: ICompanyEditRequestBody = {
      VAT: action.payload.data.VAT,
      trader_id: action.payload.data.trader_id,
      companyName: action.payload.data.companyName,
      companyEmail: action.payload.data.companyEmail,
      iban: action.payload.data.iban || undefined,
      address: {
        city: action.payload.data.headQuarters.city,
        number: action.payload.data.headQuarters.number,
        street: action.payload.data.headQuarters.street,
        postcode: action.payload.data.headQuarters.postcode,
      },
      zip: action.payload.data.headQuarters.postcode.toString(),
      mission_language: action.payload.data.missionLanguages,
      website: action.payload.data.website,
      password: action.payload.data.password,
    };

    const { data } = yield call(
      httpClient.put,
      `/backoffice/v1/intervention_partnerships/${action.payload.data.intervention_partnership_id}`,
      body,
    );

    yield put(authActions.editCompanySuccess(data));
    action.payload.functions.success();
  } catch (err: any) {
    action.payload.functions.error(err);
    yield put(authActions.editCompanyFailure());
  }
}

export default editCompany;
